import { ChangeDetectionStrategy, Component, inject, input, InputSignal, output, OutputEmitterRef, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { IconComponent } from '@libs/components/icons';
import { ButtonComponent } from '@libs/common/components';
import { ViewportService } from '@libs/shared/services';

@Component({
  selector: 'ui-order-selection-bar',
  templateUrl: './order-selection-bar.component.html',
  styleUrl: './order-selection-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, IconComponent],
})
export class OrderSelectionBarComponent {
  public isMobile: Signal<boolean> = toSignal(inject(ViewportService).isMobile(), { initialValue: false });

  public selectedCount: InputSignal<number> = input.required();
  public isLoading: InputSignal<boolean> = input(false);

  public addToCartClicked: OutputEmitterRef<void> = output();
  public cancelled: OutputEmitterRef<void> = output();
}
